import type { IFileElement } from '@chainlit/react-client';

import { FileElement } from '@/components/Elements/File';
import { Attachment } from '@/components/chat/MessageComposer/Attachment';

interface Props {
    items: IFileElement[];
    compact?: boolean;
}

const InlinedFileList = ({ items, compact }: Props) => {
    if (compact) {
        return (
            <div className="flex flex-wrap justify-end gap-2">
                {items.map((file, i) => (
                    <Attachment key={i} name={file.name} mime={file.mime ?? ''} />
                ))}
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2 w-full">
            {items.map((file, i) => {
                return (
                    <div key={i} className="w-full">
                        <FileElement element={file} />
                    </div>
                );
            })}
        </div>
    );
};

export { InlinedFileList };
